export default "__VITE_ASSET__D1NTp_49__"